//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import {
		inventory,
		api_SellItem,
		userRedeem
	} from '@/api'
	//背包信息，出售，提取，取消提取
	export default {
		name: 'warehouse',
		data() {
			return {
				Height: 0,
				into:new Audio(require('../resources/audio/into.mp3')),
				disabled: false, //禁用加载
				/*数据相关*/
				pager: {
					pageNo: 1,
					pageSize: 40
				},
				sort_item: {
					text: '按获取时间排序',
					direction: 'desc',
					sort: 'getTime'
				},
				search_key: '',
				list: [], //列表
				totalprice: 0, //总额
				totalRows: 0, //总数
				/*选择相关*/
				choice_num: 0, //选中数量
				checkAll: false, //全选状态
				warehouse_key:1,//背包列表key
				//新物品展示
				renew:[],
			}
		},
		components: {
			down: () => import('./components/down/index.vue'),
			search: () => import('./components/search/index.vue'),
			whSwiper: () => import('./components/swiper/index.vue'),
		},

		created() {
			this.getrucksacklist()
		},

		mounted() {
			this.Height = document.documentElement.clientHeight || document.body.clientHeight
			this.into.play()
		},
		methods: {
			/*获取*/
			//获取背包列表			
			getrucksacklist() {
				this.set_official_loading(true)

				let alreadyIds = JSON.parse(sessionStorage.getItem('renew'))

				console.log(alreadyIds);

				inventory({ current :1 , size: 999999}).then(res => {
					if(res.data.code === 0){
						//this.totalprice = res.data.data
						this.totalRows = res.data.data.totalItems
						let arr = res.data.data.data
						this.totalprice = arr.map(_=>_.price).reduce((a,b)=> a+b,0)

						arr.map(item => item.choice = false)
						this.list = arr
						this.choice_num = 0
						if(alreadyIds.length > 0){
							this.renew = arr.filter(_=> alreadyIds.indexOf(_.mSerial) > -1)
						}
						this.set_official_loading(false)
						this.warehouse_key += 1
					}else{
						this.set_official_loading(false)
					}
				}).catch(err => this.set_official_loading(false))
			},


			//排序
			down_item(item) {
				this.sort_item = item
				this.getrucksacklist()
			},

			//搜索
			to_search(key) {
				this.search_key = key
				this.getrucksacklist()
			},

			/*选择相关*/
			//全选
			All_choice() {
				if (this.checkAll) {
					this.checkAll = false
					this.list.map(item => item.choice = false)
					this.calculation()
				} else {
					this.checkAll = true
					this.list.filter(_=>_.lockType == 0).map(item => item.choice = true)
					this.calculation()
				}
			},

			//单选
			Single(item) {
				item.choice = !item.choice

				if(item.lockType == 1)
					item.choice = false

				this.calculation()
				this.monitorAll()
			},


			// 计算选择数量
			calculation() {
				let arr = this.list.filter(item => item.choice)
				this.choice_num = arr.length
			},

			//全选监听
			monitorAll() {
				let monitor = this.list.find(item => {
					return !item.choice
				})
				if (monitor) {
					this.checkAll = false
				} else {
					this.checkAll = true
				}
			},

			/*操作相关*/
			//兑换
			tosell() {
				let arr = this.list.filter(item => item.choice)
				if (arr.length > 0) {
					let listing = arr.filter(item => item.lockType == 1)
					if (listing.length == 0) {
						let data = arr.map(item => item.mSerial)
						api_SellItem({lstmSerial: data}).then(res => {
							if (res.data.code===0) {
								this.$toast.success( res.data.msg)
								this.getrucksacklist()
							} else {
								this.$toast.error( res.data.msg)
							}
						})
					} else {
						this.$toast.error( '包含提取中饰品,请重新选择')
					}
				} else {
					this.$toast.error( '未选择饰品')
				}
			},

			//提取
			todraw() {
				//验证steam
				let arr = this.list.filter(item => item.choice)
				if (arr.length > 0) {
					let listing = arr.filter(item => item.lockType == 1)
					if (listing.length == 0) {
						let data = arr.map(item => item.mSerial)
						userRedeem({ lstmSerial: data }).then(res => {
							if (res.data.code===0) {
								this.$toast.success( res.data.msg)
								this.getrucksacklist()
							} else {
								this.$toast.error( res.data.msg)
							}
						})
					} else {
						this.$toast.error( '包含提取中饰品,请重新选择')
					}
				} else {
					this.$toast.error( '未选择饰品')
				}
			},

			//取消提取
			tocancelDraw() {
				let arr = this.list.filter(item => item.choice)
				if (arr.length > 0) {
					let listing = arr.filter(item => item.lockType != 1)
					if (listing.length == 0) {
						let data = arr.map(item => item.id)
						cancelDraw(data).then(res => {
							if (res.data.success) {
								this.$message({
									message: res.data.msg,
									type: 'success'
								})
								this.resetState()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'success'
								})
							}
						})
					} else {
						this.$message({
							message: '请选择提取中饰品进行取消',
							type: 'success'
						})
					}
				} else {
					this.$message({
						message: '未选择饰品',
						type: 'success'
					})
				}
			},
			
			// 重置状态
			resetState() {
				this.getrucksacklist()
				this.monitorAll()
				this.choice_num = 0
				this.checkAll = false
			},
			
			//刮刮乐关闭
			close(){
				this.getrucksacklist()
			}
		}
	}
